var map = {
	"./about/about-us-one/about-us-one.module": "./src/app/about/about-us-one/about-us-one.module.ts",
	"./about/about-us-two/about-us-two.module": "./src/app/about/about-us-two/about-us-two.module.ts",
	"./blog/blog-detail/blog-detail.module": "./src/app/blog/blog-detail/blog-detail.module.ts",
	"./blog/blog-right-column/blog-right-column.module": "./src/app/blog/blog-right-column/blog-right-column.module.ts",
	"./blog/blog-three-column/blog-three-column.module": "./src/app/blog/blog-three-column/blog-three-column.module.ts",
	"./blog/blog-two-column/blog-two-column.module": "./src/app/blog/blog-two-column/blog-two-column.module.ts",
	"./blog/blog/blog.module": "./src/app/blog/blog/blog.module.ts",
	"./cloud-analytics/cloud-analytics.module": "./src/app/cloud-analytics/cloud-analytics.module.ts",
	"./cloud-compute/cloud-compute.module": "./src/app/cloud-compute/cloud-compute.module.ts",
	"./cloud-databases/cloud-databases.module": "./src/app/cloud-databases/cloud-databases.module.ts",
	"./cloud-hosting/cloud-hosting.module": "./src/app/cloud-hosting/cloud-hosting.module.ts",
	"./cloud-media-services/cloud-media-services.module": "./src/app/cloud-media-services/cloud-media-services.module.ts",
	"./contact-us/contact-us1/contact-us1.module": "./src/app/contact-us/contact-us1/contact-us1.module.ts",
	"./contact-us/contact-us2/contact-us2.module": "./src/app/contact-us/contact-us2/contact-us2.module.ts",
	"./landing-page1/landing-page1.module": "./src/app/landing-page1/landing-page1.module.ts",
	"./landing-page2/landing-page2.module": "./src/app/landing-page2/landing-page2.module.ts",
	"./landing-page3/landing-page3.module": "./src/app/landing-page3/landing-page3.module.ts",
	"./pages/clients/clients.module": "./src/app/pages/clients/clients.module.ts",
	"./pages/error404/error404.module": "./src/app/pages/error404/error404.module.ts",
	"./pages/faq/faq.module": "./src/app/pages/faq/faq.module.ts",
	"./pages/our-team/our-team.module": "./src/app/pages/our-team/our-team.module.ts",
	"./pages/pricing-plan/pricing-plan.module": "./src/app/pages/pricing-plan/pricing-plan.module.ts",
	"./pages/services/services.module": "./src/app/pages/services/services.module.ts",
	"./portfolio/portfolio-details/portfolio-details.module": "./src/app/portfolio/portfolio-details/portfolio-details.module.ts",
	"./portfolio/portfolio2columns/portfolio2columns.module": "./src/app/portfolio/portfolio2columns/portfolio2columns.module.ts",
	"./portfolio/portfolio3columns/portfolio3columns.module": "./src/app/portfolio/portfolio3columns/portfolio3columns.module.ts",
	"./portfolio/portfolio4columns/portfolio4columns.module": "./src/app/portfolio/portfolio4columns/portfolio4columns.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;